import img1 from "../assets/image/001.jpg";
import img2 from "../assets/image/002.png";
import img3 from "../assets/image/003.png";
import img4 from "../assets/image/004.png";
import img6 from "../assets/image/006.png";
import img7 from "../assets/image/007.png";
import img8 from "../assets/image/008.png";
import { BiSupport } from "react-icons/bi";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <>
      <div style={{ backgroundColor: "white" }}>
        <footer
          className="footer-container container"
          style={{ borderTop: "3px solid #135923", marginTop: "3rem" }}
        >
          <div className="d-flex flex-wrap p-5 justify-content-between">
            <div>
              <p className="text-dark fs-6 mt-3">
                <b>درباره جمه صب</b>
              </p>
              <Link
                to="/about-us"
                className="text-secondary text-decoration-none size3 d-block font-regular pb-2"
              >
                درباره ما
              </Link>
              <a
                href="#"
                className="text-secondary text-decoration-none size3 d-block font-regular pb-2"
              >
                مجله جمه صب
              </a>
              <a
                href="#"
                className="text-secondary text-decoration-none size3 d-block font-regular pb-2"
              >
                فرصتهای شغلی
              </a>
              <a
                href="#"
                className="text-secondary text-decoration-none size3 d-block font-regular pb-2"
              >
                اپلیکیشن جمه صب
              </a>
            </div>
            <div>
              <p className="text-dark fs-6 mt-3">
                <b>پشتیبانی جمه صب</b>
              </p>
              <Link
                to="/connection-us"
                className="text-secondary text-decoration-none size3 d-block font-regular pb-2"
              >
                تماس باما
              </Link>
              <Link
                to="/tour-condition"
                className="text-secondary text-decoration-none size3 d-block font-regular pb-2"
              >
                قوانین و مقررات
              </Link>
              <a
                href="#"
                className="text-secondary text-decoration-none size3 d-block font-regular pb-2"
              >
                سوالات متداول
              </a>
              <a
                href="#"
                className="text-secondary text-decoration-none size3 d-block font-regular pb-2"
              >
                راهنمای دریافت رمز پویا از تمام بانکها
              </a>
            </div>
            <div>
              <p className="text-dark fs-6 mt-3">
                <b>چرا جمه صب</b>
              </p>
              <a
                href="#"
                className="text-secondary text-decoration-none size3 d-block font-regular pb-2"
              >
                مجوزها
              </a>
              <a
                href="#"
                className="text-secondary text-decoration-none size3 d-block font-regular pb-2"
              >
                جمه صب در رسانه ها
              </a>
            </div>
            <div>
              <p className="text-dark fs-6 mt-3">
                <b>تماس با پشتیبانی</b>
              </p>
              <a className="text-secondary text-decoration-none size3 digits d-block digits pb-2">
                <span className="me-2" style={{ fontSize: "20px" }}>
                  <BiSupport></BiSupport>
                </span>
                09115291152
              </a>
              <a className="text-secondary text-decoration-none size3 digits d-block digits pb-2">
                <span className="me-2" style={{ fontSize: "20px" }}>
                  <BiSupport></BiSupport>
                </span>
                01732355588
              </a>

              <button
                className="btn btn-outline-secondary round mt-4 size3 shadow font-regular pb-2"
                style={{
                  backgroundColor: "#0B6422",
                  color: "white",
                  fontSize: 15,
                }}
              >
                پرداخت صورت حساب
              </button>
            </div>
            <div className="d-flex flex-column">
              <p className="text-dark fs-6 mt-3">
                <b>مارا در فضای مجازی دنبال کنید</b>
              </p>
              <div className="text-center d-flex flex-column">
                <a
                  href="https://t.me/jome_sob"
                  className="my-1 k-btn-instagram"
                >
                  اینستاگرام جمه صب
                  {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={16}
                    height={16}
                    fill="currentColor"
                    class="bi bi-telegram"
                    viewBox="0 0 16 16"
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.287 5.906c-.778.324-2.334.994-4.666 2.01-.378.15-.577.298-.595.442-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294.26.006.549-.1.868-.32 2.179-1.471 3.304-2.214 3.374-2.23.05-.012.12-.026.166.016.047.041.042.12.037.141-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8.154 8.154 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629.093.06.183.125.27.187.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.426 1.426 0 0 0-.013-.315.337.337 0 0 0-.114-.217.526.526 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09z" />
                  </svg> */}
                </a>
                <a
                  href="https://www.instagram.com/jome_sob"
                  className="my-1 k-btn-telegram"
                >
                  {" "}
                  تلگرام جمه صب
                  {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ color: "#8a5fc2", marginRight: "5px" }}
                    width={16}
                    height={16}
                    fill="currentColor"
                    className="bi bi-instagram"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
                  </svg> */}
                </a>
                {/* <a href="https://twitter.com/jomesob">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ color: "#5fc26c", marginRight: "5px" }}
                    width={16}
                    height={16}
                    fill="currentColor"
                    className="bi bi-twitter"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z" />
                  </svg>
                </a> */}
                <a
                  href="https://www.aparat.com/jomesob"
                  className="my-1 k-btn-aparat"
                >
                  آپارات جمه صب
                  {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width={20}
                    height={20}
                    viewBox="0 0 48 48"
                    style={{ fill: "#000000" }}
                  >
                    <path
                      fill="#263238"
                      d="M21.881 6.136l-4.315-.974c-3.52-.795-7.017 1.414-7.812 4.934l-.983 4.351C11.603 9.95 16.357 6.788 21.881 6.136zM6.136 26.119l-.974 4.315c-.795 3.52 1.414 7.017 4.934 7.812l4.351.983C9.95 36.396 6.788 31.643 6.136 26.119zM37.904 9.754l-4.351-.983c4.497 2.832 7.659 7.586 8.311 13.109l.974-4.315C43.633 14.047 41.424 10.549 37.904 9.754zM26.119 41.864l4.315.974c3.52.795 7.017-1.414 7.812-4.934l.983-4.351C36.397 38.05 31.643 41.212 26.119 41.864z"
                    ></path>
                    <path
                      fill="#e91e63"
                      d="M24,8C15.163,8,8,15.163,8,24s7.163,16,16,16s16-7.163,16-16S32.837,8,24,8z M20,13 c2.209,0,4,1.791,4,4c0,2.209-1.791,4-4,4s-4-1.791-4-4C16,14.791,17.791,13,20,13z M17,32c-2.209,0-4-1.791-4-4 c0-2.209,1.791-4,4-4s4,1.791,4,4C21,30.209,19.209,32,17,32z M22,24c0-1.105,0.895-2,2-2s2,0.895,2,2c0,1.105-0.895,2-2,2 S22,25.105,22,24z M28,35c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C32,33.209,30.209,35,28,35z M31,24 c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C35,22.209,33.209,24,31,24z"
                    ></path>
                  </svg> */}
                </a>
              </div>
            </div>
            <div
              className="d-flex flex-wrap-reverse justify-content-end"
              style={{ width: "100%" }}
            >
              {/* <div className="d-flex flex-wrap col-lg-4 col-12 justify-content-between mt-3">
              <div>
                <a>
                  <img src={img1} className="namad m-2" />
                </a>
                <a>
                  <img src={img2} className="namad m-2" />
                </a>
              </div>
              <div>
                <a>
                  <img src={img3} className="namad m-2" />
                </a>
                <a>
                  <img src={img4} className="namad m-2" />
                </a>
              </div>
              <div>
                <a>
                  <img src={img1} className="namad m-2" />
                </a>
                <a>
                  <img src={img6} className="namad m-2" />
                </a>
              </div>
              <div>
                <a>
                  <img src={img7} className="namad m-2" />
                </a>
                <a>
                  <img src={img8} className="namad m-2" />
                </a>
              </div>
            </div> */}
              <div className="  mt-3 ">
                <div className="input-group d-flex flex-wrap">
                  <div
                    className="size3 email mx-4"
                    style={{
                      width: "30%",
                      fontSize: 14,
                    }}
                  >
                    شماره تماس خود را به ما دهید تا از آخرین اخبار ما مطلع شوید.
                  </div>
                  <input
                    type="text"
                    className="form-control mk-fs"
                    style={{ borderRadius: 8 }}
                    placeholder="شماره تماس خود را وارد کنید."
                    aria-label="Recipient's username"
                    aria-describedby="button-addon2"
                    style={{
                      width: "45%",
                    }}
                  />
                  <button
                    className="btn btn-light round border ms-2 button-padding text-secondary mk-fs"
                    style={{ borderRadius: 8, width: "15%" }}
                    type="button"
                    id="button-addon2"
                  >
                    ثبت نام
                  </button>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}
